export enum JackpotWonType {
    HAND_ROYAL_FLUSH = 'royalflush',
    HAND_STRAIGHT_FLUSH = 'straightflush',
}
